import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PostmethodService } from '../../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class NoResponseService {

  constructor(private ws: PostmethodService) { }
noresponse(request: any) {
  return this.ws.wsPost(request, environment.baseUrl + "/lead/tcLeadMovement");
}
}
